import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText, CircularProgress } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import DialogLoader from '../../../../components/Loader/DialogLoader';

import { InputBaseField, SelectField, TextareaField } from '../../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../../Services/APIService';
import { withSnackbar } from "./../../../../components/Message/Alert";
import { handleNumberKeyPress, isDigitsOnly, IsVerizonSIM, maskAccountNumber, saveActivlityLogInfo } from '../../../../../src/components/Common/Extensions';

import * as signalR from "@microsoft/signalr";


import useStyles from "./styles";

function SwapBulk({ dialogOpenClose, handleClose, handleSuccessClose, accountNumber, ...props }) {

    const classes = useStyles();

    //const signalRConnectionId = sessionStorage.getItem('signalRConnectionId');

    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        MDNs: "",
        ProcessTypeId: 5,
        ZipCode: "",
        AccountNumber: props.customerNumber,
        Network: "Verizon",
        Filename: "",
        //SignalRConnectionId: signalRConnectionId,
        ICCs: "",
        LineName: "",
        PackageName: "Unlimited Plan",
        PackagePrice: 0,
    });
    const { showMessage } = props;
    const [processResult, setProcessResult] = useState();


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleChangeMdn = e => {
        const { name, value } = e.target;
        const cleanedValue = value.replace(/[A-Za-z]/g, '');
        const lines = cleanedValue.split('\n');
        if (lines.length > 200) {
            return;
        }
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [errorMessages, setErrorMessages] = useState({

    });

    const swapOptions = [
        {
            label: 'Swap MDN',
            value: 'swapMdn'
        }
    ]
    const networkOptions = [
        {
            label: 'GSM',
            value: 'TMO'
        },
        {
            label: 'CDMA',
            value: 'Verizon'
        }
    ]

    const validateProcess = (errorList) => {
        if (!state.MDNs) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMDNs: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMDNs: false
            }));
        }
    }




    const processSwap = () => {
        let errorList = [];

        validateProcess(errorList);

        if (errorList.length > 0) return;

        setIsLoading(true);

        PostDataAPI("BulkSetup/ProcessBulkConnection", state, true).then((result) => {
            if (result.success && result.data) {
                debugger
                setProcessResult(result.data);
                showMessage("success", "Bulk Swap Completed", "success", 3000);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    };

    const [bulkTime, setBulkTime] = useState();
    const [processUpdate, setProcessUpdate] = useState([]);


    const [showErrors, setShowErrors] = useState(false);

    const logBulkDialogActivity = (activity, details, activityStatus = "Success") => {
        saveActivlityLogInfo(
            "Line Management",
            activity,
            `${details}. Account: ${maskAccountNumber(props.customerNumber)}`,
            props.customerNumber,
            null,
            activityStatus
        );
    };

    const handleShowErrors = () => {
        if (processUpdate.length < 1) {
            logBulkDialogActivity(
                "Error Logs Dialog Open Failed",
                "User attempted to open Error Logs dialog from Bulk Swapping, but no error logs were available",
                "Failed"
            );
            return;
        }

        logBulkDialogActivity(
            "Error Logs Dialog Opened",
            `User opened Error Logs dialog from Bulk Swapping with ${processUpdate.length} error log entries`
        );
        setShowErrors(true);
    };

    const handleCloseErrors = () => {
        setShowErrors(false);
    };


    const baseSignalUrl = process.env.REACT_APP_SIGNAL_URL;

    //useEffect(() => {
    //    const hubConnection = new signalR.HubConnectionBuilder()
    //        .withUrl(baseSignalUrl) // Replace with your SignalR hub URL
    //        .withAutomaticReconnect()
    //        .build();

    //    // Handle incoming messages from the "BulkProcessUpdation" event
    //    hubConnection.on("BulkProcessTime", (message) => {
    //        setBulkTime(message); // Update state or perform an action with the message
    //    });

    //    hubConnection.on("BulkProcessUpdation", (message) => {
    //        setProcessUpdate(prevMessages => [...prevMessages, message]);
    //    });

    //    // Start the connection
    //    hubConnection
    //        .start()
    //        .then(() => {
    //            console.log("Connected to SignalR hub.");
    //        })
    //        .catch((error) => {
    //            console.error("Failed to connect to SignalR hub:", error);
    //        });

    //    // Optional: Cleanup on unmount
    //    return () => {
    //        hubConnection.stop();
    //    };
    //}, []);

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                PaperComponent={DraggableComponent}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Bulk Swapping</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>

                        <div className={classes.content}>
                            <Grid container>
                                <Grid item lg={12}>
                                    <Typography className={classes.labelText}><b>Account: {props.customerNumber} - {props.customerName}</b></Typography>

                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item lg={5} sm={12}>
                                    <Grid row >
                                        <Typography className={classes.valueText} style={{ marginTop: '10px' }}>Add MDN Numbers </Typography>
                                        <TextareaField
                                            name="MDNs"
                                            value={state.MDNs}
                                            onChange={handleChangeMdn}
                                            placeholder="MDN Numbers"
                                            type="text"
                                            rows={10}
                                            onKeyPress={(e) => handleChangeMdn(e)}
                                            Disabled={isLoading ? true : ''}
                                        />
                                        {errorMessages.errorMDNs && !state.MDNs ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter mdn numbers
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>

                                <Grid item lg={7} sm={12} style={{ marginTop: '35px' }}>

                                    <Grid row>
                                        <div className={classes.processCount}>
                                            {bulkTime ?
                                                <span style={{ color: '#94fb94', fontSize: '16px' }}> {processUpdate[0]}<br></br>{bulkTime} </span> :
                                                <>
                                                    <h3>Monitor</h3>
                                                </>
                                            }

                                        </div>
                                    </Grid>


                                    <Grid row >
                                        <Label title="Choose Network" size={12} />
                                        <SelectField
                                            name="Network"
                                            options={networkOptions}
                                            value={state.Network}
                                            onChange={handleChange}
                                        />
                                    </Grid>




                                    {/* <Grid row >
                                        <Typography className={classes.title}></Typography>

                                        <SelectField
                                            name="orderStatus"
                                            options={swapOptions}
                                            value={'swapMdn'}
                                        />
                                    </Grid> */}

                                    <Grid row style={{ textAlign: 'right' }}>

                                        {processUpdate.length > 0 ? <Button className={classes.errorBtn}  onClick={handleShowErrors}>View All Errors</Button> : ''}

                                        {processResult ?
                                            <a className={classes.changeBtn} target='_blank' href={`/Documents/TelispireBulkProcess/${props.customerNumber}/${processResult? processResult.fileName: ''}`}>
                                               Download Report
                                            </a> : ''}

                                            {processResult? processResult.fileName: ''}

                                        <Button className={classes.changeBtn} onClick={processSwap}>{isLoading ? <CircularProgress size={18} className={classes.circularProgressBar} color="secondary" /> : ''} {isLoading ? 'Processing' : 'Start Swapping'} </Button>
                                    </Grid>


                                </Grid>
                            </Grid>
                        </div>



                    </div>


                </div>
            </Dialog>

            <Dialog open={showErrors}
                classes={{ paper: classes.dialogPaper }}
                PaperComponent={DraggableComponent} maxWidth="lg" onClose={handleCloseErrors}>
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Error Logs</Typography>
                            <Icon className={classes.closeIcon} onClick={handleCloseErrors} color="primary"><CloseIcon /></Icon>
                        </div>

                        <div className={classes.content}>
                            <Scrollbars autoHeight autoHeightMax={'450px'}>
                                {processUpdate}
                            </Scrollbars>
                        </div>
                    </div>
                </div>

            </Dialog>
        </>
    )

}
export default withSnackbar(SwapBulk);
